import { Tag } from '@arco-design/web-react';

import type { StorageClassDisplayInfo } from '@/delivery-type-plugin/capabilities/maas-model-storage/storageVolume';

export type StorageClassDisplayLayout = 'inline' | 'stacked';

export interface StorageClassDisplayProps extends StorageClassDisplayInfo {
  /** inline：单行展示（确认/详情）；stacked：首行 alias+provisioner、次行 name（创建/编辑卡片） */
  layout?: StorageClassDisplayLayout;
}

/** 存储类展示：alias + name + provisioner */
export function StorageClassDisplay({ alias, name, provisioner, layout = 'inline' }: StorageClassDisplayProps) {
  const aliasText = alias ? String(alias).trim() : '';
  const nameText = name ? String(name).trim() : '';
  const showNameLine = !!nameText && nameText !== aliasText;

  if (!aliasText && !nameText && !provisioner) {
    return <span>-</span>;
  }

  if (layout === 'stacked') {
    const showFirstLine = !!aliasText || !!provisioner;
    if (!showFirstLine && !showNameLine) {
      return <span>-</span>;
    }
    return (
      <span style={{ display: 'inline-flex', flexDirection: 'column', gap: 4 }}>
        {showFirstLine ? (
          <span style={{ display: 'inline-flex', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
            {aliasText ? <span>{aliasText}</span> : null}
            {provisioner ? (
              <Tag color="orange" size="small">
                {provisioner}
              </Tag>
            ) : null}
          </span>
        ) : null}
        {showNameLine ? <span style={{ color: 'var(--color-text-3)' }}>{nameText}</span> : null}
      </span>
    );
  }

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
      {aliasText ? <span>{aliasText}</span> : null}
      {showNameLine ? (
        <span style={{ color: 'var(--color-text-3)' }}>{nameText}</span>
      ) : !aliasText && nameText ? (
        <span>{nameText}</span>
      ) : null}
      {provisioner ? (
        <Tag color="orange" size="small">
          {provisioner}
        </Tag>
      ) : null}
    </span>
  );
}
